import React, { Component } from 'react';
import { normalize } from 'path';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';

import AsyncRoute from './HOC/AsyncRoute';
import { isDev } from './utils/util';
import { isPC } from './utils/browserDetector';

// pages
const HomePage = AsyncRoute(() => import(/* webpackChunkName: "home" */'./pages/HomePage/HomePage'));
const HistoryPage = AsyncRoute(() => import(/* webpackChunkName: "history" */'./pages/HistoryPage/HistoryPage'));
const RecyclePage = AsyncRoute(() => import(/* webpackChunkName: "recycle" */'./pages/RecyclePage/RecyclePage'));
const EditorWrapper = AsyncRoute(() => import(/* webpackChunkName: "writing" */'./components/EditorWrapper/EditorWrapper'));
const PreviewPage = AsyncRoute(() => import(/* webpackChunkName: "preview" */'./pages/PreviewPage/PreviewPage'));
const ForbiddenPage = AsyncRoute(() => import(/* webpackChunkName: "forbidden" */'./pages/ForbiddenPage/ForbiddenPage'));
const NotFoundPage = AsyncRoute(() => import(/* webpackChunkName: "notFound" */'./pages/NotFoundPage/NotFoundPage'));
const PayNoteSettingPage = AsyncRoute(() => import(/* webpackChunkName: "paynote" */'./pages/PayNoteSettingPage/PayNoteSettingPage'));
const PublishStyleSettingPage = AsyncRoute(() => import(/* webpackChunkName: "paynote" */'./pages/PublishStyleSettingPage/PublishStyleSettingPage'));

const PCRoute = ({ component: WrapperComponent, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (isPC()) {
        return (
          <WrapperComponent {...props}/>
        );
      }
      return (
        <Redirect to={'/forbidden'}/>
      );
    }}
  />
);

@withRouter
export default class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.trackPage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const locationChanged = nextProps.location !== this.props.location;
    if (locationChanged) {
      this.trackPage(nextProps);
    }
  }

  trackPage = (props) => {
    if (!isDev) {
      const { location: { pathname } } = props;
      const fullPath = normalize(`${process.env.publicPath}${pathname}/`);
      _hmt && _hmt.push(['_trackPageview', fullPath]); // eslint-disable-line no-undef,no-unused-expressions
    }
  };

  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <Switch>
        <PCRoute exact path="/" component={HomePage}/>
        <PCRoute exact path='/notebooks/:nbId' component={HomePage}/>
        <PCRoute exact path='/notebooks/:nbId/notes/:noteId' component={HomePage}/>
        <PCRoute path='/recycle/:noteId' component={RecyclePage}/>
        <PCRoute path='/recycle' component={RecyclePage}/>
        <PCRoute path='/notebooks/:nbId/notes/:noteId/history/:historyId' component={HistoryPage}/>
        <PCRoute path='/notebooks/:nbId/notes/:noteId/history' component={HistoryPage}/>
        <PCRoute exact path='/notebooks/:nbId/notes/:noteId/writing' component={EditorWrapper}/>
        <PCRoute exact path='/notebooks/:nbId/notes/:noteId/preview' component={PreviewPage}/>
        <PCRoute exact path='/notebooks/:nbId/notes/:noteId/pnsetting' component={PayNoteSettingPage}/>
        <PCRoute exact path='/notebooks/:nbId/notes/:noteId/pssetting' component={PublishStyleSettingPage}/>
        {!isPC() && <Route path="/forbidden" component={ForbiddenPage}/>}
        <PCRoute component={NotFoundPage}/>
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Routes.js